module.exports = __webpack_public_path__ + "040c2362721132d4bb23052fe167a5ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/welcome-images/images/welcome-diamond-pattern-right.png
// module id = 333
// module chunks = 0